import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-netBillAmountHistory',
  templateUrl: './netBillAmountHistory.component.html',
  styleUrls: ['./netBillAmountHistory.component.scss']
})
export class NetBillAmountHistoryComponent implements OnInit {

  @Input() data;

  rows: any[] = [];

  private monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.rows = Array.isArray(this.data) ? 
      [...this.data].sort((a, b) =>
        new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
      ) : [];
  }

  formatAmount(value: any): string {
    if (value === null || value === undefined || value === '') { return '—'; }
    const num = Number(value);
    if (isNaN(num)) { return String(value); }
    return num.toLocaleString('en-IN');
  }

  formatDate(iso: any): string {
    if (!iso) { return '—'; }
    const d = new Date(iso);
    if (isNaN(d.getTime())) { return String(iso); }
    const date = `${d.getDate()} ${this.monthNames[d.getMonth()]} ${d.getFullYear()}`;
    const time = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    return `${date}, ${time}`;
  }
}
